<template>
  <footer class="footer">
    <div
        v-if="type !== 'picky-cat'"
        class="arrow-btn"
        :class="{'arrow-btn_visible': arrowVisible}"
        id="arrowTop"
        @click="scrollTop"
    ></div>
    <div class="footer__container container">
      <div class="footer__left">
        <a :href="`/${rootLink}`" class="footer__logo">
          <img :src="`/${imageDirectory}/purina-one-new_cat/dist/assets/logo_alt.svg`" alt="">
        </a>
        <div class="footer__copy">
          <sup>©</sup>Компания Nestlé, {{ date }} г. Все права защищены.<br>
          <sup>®</sup>Владелец товарных знаков: <br class="_g-visible-tablet">Société des Produits Nestlé S.A. (Швейцария)
          <!-- <p>Purina {{ date }}<sup>®</sup> Владелец товарных знаков:<br> Société&nbsp;des&nbsp;Produits&nbsp;Nestlé&nbsp;S.A.(Швейцария)</p> -->
        </div>

      </div>
      <div class="footer__nav">
        <div class="footer__nav-column">
          <a href="https://www.purina.ru/terms-and-conditions" target="_blank">Правовая информация</a>
          <a href="https://www.purina.ru/data-policy" target="_blank">Политика конфиденциальности</a>
        </div>
        <div class="footer__nav-column">
          <a href="/contacts">Контакты</a>
          <a href="/sitemap">Карта сайта</a>
        </div>
      </div>
    </div>
  </footer>
  <div class="red-strip">
    <div class="red-strip__container container">
      <a class="red-strip__logo" href="https://www.purina.ru/" target="_blank">
        <img src="/themes/custom/purina_one/purina-one-new_cat/src/img/purina-logo.svg" alt="">
      </a>
      <div class="red-strip__text">Ваш питомец — наше вдохновение<sup>®</sup></div>
    </div>
  </div>
</template>
<script setup>
  import { ref, onMounted, computed } from 'vue';
  const TOP_OFFSET = 500;

  const props = defineProps({
    type: {
      type: String,
      default: ''
    },
    imageDirectory: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    isMain: {
      type: Boolean,
      default: false
    }
  });

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  const arrowVisible = ref(false);

  const handleWindowScroll = () => {
    arrowVisible.value = document.body.scrollTop > TOP_OFFSET || document.documentElement.scrollTop > TOP_OFFSET;
  }

  const rootLink = computed(() => {
    return (!props.type || props.isMain )? '' : props.type;
  });

  onMounted(() => {
    window.addEventListener('scroll', handleWindowScroll);
    handleWindowScroll();
  });
</script>
